import React, { useEffect, useState } from "react";
import Footer from "../../Base/Footer";
import Header from "../../Base/Header";
import Playlist from "../../Components/PlaylistView/Playlist";
import ReactPaginate from "react-paginate";
import styles from "../../Styles/Playlist/playlist.module.css";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { makeStyles } from "@mui/styles";
import {
  getFilteredPlaylists,
  getFilteredPlaylists2,
} from "../../helper/Playlists/playlist";
import { getAllCategories } from "../../helper/categoryApiCalls/category";
import Categories from "./Categories";
import { getAllCreators } from "../../helper/creatorsApiCalls/creator";
import Creators from "./Creators";
import { useParams } from "react-router-dom";
import Languages from "./Languages";
import RadioBox from "./radioBox";
import { rating } from "./Rating";
import filter from "../../images/filter.svg";
import FilterModal from "../../Components/Modals/FilterModal";

const useStyles = makeStyles({
  root: {
    width: "100%",
    border: "none",
    outline: "none",
    color: "var(--text-primary) !important",
    backgroundColor: "var(--bg-secondary) !important",
    "& .MuiAccordionSummary-root": {
      color: "var(--text-primary) !important",
    },
    "& .MuiTypography-root": {
      color: "var(--text-primary) !important",
    },
    "& .MuiSvgIcon-root": {
      color: "var(--text-primary) !important",
    },
  },
  summary: {
    backgroundColor: "transparent",
    color: "var(--text-primary) !important",
    "& .MuiSvgIcon-root": {
      color: "var(--text-primary) !important",
    },
  },
});

const CategoricalSearch = () => {
  const names = [
    "English",
    "Hindi",
    "Marathi",
    "Konkani",
    "Bengali",
    "Tamil",
    "Kannada",
    "German",
    "Chinese",
    "Telugu",
  ];

  const params = useParams();
  const pagetype = params.pagetype;
  const id = params.id;

  const classes = useStyles();

  const [playlists, setPlaylists] = React.useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(0);

  const [open, setOpen] = useState(false);
  const [category, setCategory] = React.useState([]);
  const [creators, setCreators] = useState([]);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(true);
  const [loadcreators, setLoadcreators] = useState(true);
  const [myFilters, setMyFilters] = useState({
    filters: {
      category: pagetype === "category" ? [id] : [],
      creator: [],

      rating: [],
      language: [],
    },
  });

  const loadFilteredPlaylists = () => {
    setError("");
    if (pagetype === "category") {
      let body = {
        languages: myFilters.filters.language,
        rating: myFilters.filters.rating[0],
      };
      let limit = 6;
      getFilteredPlaylists(id, currentPage, limit, "newest", body).then(
        (data) => {
          console.log(data, "data");
          if (data.success === false) {
            setError(data.message);
          } else {
            const totalPageCount = Math.ceil(data.data.total / limit);
            setTotalPageCount(totalPageCount);
            setPlaylists(data.data.playlist);

            setBusy(false);
          }
        },
      );
    } else {
      let body = {
        languages: myFilters.filters.language,
        rating: myFilters.filters.rating[0],
      };
      let limit = 6;
      getFilteredPlaylists2(id, currentPage, limit, "newest", body).then(
        (data) => {
          console.log(data, "data");
          if (data.success === false) {
            setError(data.message);
          } else {
            const totalPageCount = Math.ceil(data.data.total / limit);
            setTotalPageCount(totalPageCount);
            setPlaylists(data.data.playlist);

            setBusy(false);
          }
        },
      );
    }
  };

  function loadAllCategories() {
    setError("");
    getAllCategories().then((data) => {
      if (data.status === "fail") {
        setError(data.message);
      } else {
        // eslint-disable-next-line array-callback-return
        data.data.map((cate) => {
          if (cate._id === id) {
            setCategory([cate]);
          }
        });
      }
    });
  }

  const handleFilters = (filters, filterBy) => {
    const newFilters = { ...myFilters };
    newFilters.filters[filterBy] = filters;
    if (filterBy === "rating") {
      let ratingValues = handleRating(filters);
      newFilters.filters[filterBy] = ratingValues;
    }
    loadFilteredPlaylists(myFilters.filters);
    setMyFilters(newFilters);
  };

  const handleRating = (value) => {
    const data = rating;
    let newArray = [];

    for (let key in data) {
      if (data[key]._id === parseInt(value)) {
        newArray = data[key].array;
      }
    }
    return newArray;
  };

  useEffect(() => {
    loadFilteredPlaylists();
    loadAllCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myFilters.filters, currentPage]);
  useEffect(() => {
    loadFilteredPlaylists();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, currentPage]);

  const CategoricalSearchPage = () => {
    return (
      <div className={styles.container}>
        {!busy ? (
          <>
            <div className={styles.topContainer}>
              {/* {pagetype === "category" && <h3>{category[0].name}</h3>} */}

              <img
                src={filter}
                alt=""
                className={styles.filtericon}
                onClick={() => setOpen((val) => !val)}
              />
            </div>

            <main className={styles.main}>
              <aside className={styles.left}>
                <p>Filters</p>
                <Accordion className={classes.root}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className={classes.summary}
                  >
                    <Typography>Ratings</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <RadioBox
                      rating={rating}
                      handleFilters={(filters) =>
                        handleFilters(filters, "rating")
                      }
                      filters={myFilters.filters}
                    />
                  </AccordionDetails>
                </Accordion>

                <Accordion className={classes.root}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>Languages</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Languages
                      handleFilters={(filters) =>
                        handleFilters(filters, "language")
                      }
                      languages={names}
                      filters={myFilters.filters}
                    />
                  </AccordionDetails>
                </Accordion>
              </aside>
              {playlists.length > 0 && (
                <div className={styles.pagedata}>
                  {playlists.length > 0 &&
                    playlists.map((playlist, index) => {
                      return (
                        <div key={index}>
                          <Playlist data={playlist} />
                        </div>
                      );
                    })}
                </div>
              )}
              {playlists.length === 0 && (
                <div className={styles.pagedata}>
                  <span className={styles.noplaylist}>
                    Sorry 😢, There are no playlists yet...
                  </span>
                </div>
              )}
              {error && (
                <div className={styles.pagedata}>
                  <span className={styles.noplaylist}>{error}</span>
                </div>
              )}
            </main>
            <div>
              <div className="flex justify-center pt-6">
                <nav aria-label="Page navigation example ">
                  <ul className="list-style-none flex   rounded-lg">
                    <li>
                      <div
                        className="relative block rounded cursor-pointer bg-transparent py-1.5 px-3 text-sm text-neutral-600 transition-all duration-300 text-black  "
                        href="/"
                        onClick={() => {
                          if (currentPage > 1) {
                            setCurrentPage(currentPage - 1);
                          }
                        }}
                      >
                        {" <"}
                      </div>
                    </li>
                    {totalPageCount > 0 &&
                      [...Array(totalPageCount)].map((e, i) => {
                        return (
                          <li key={i}>
                            <div
                              className={
                                "relative block rounded  py-1.5 px-3 text-sm text-blue-500 transition-all duration-300 cursor-pointer" +
                                (currentPage === i + 1 ? "bg-black" : "")
                              }
                              href="/"
                              onClick={() => setCurrentPage(i + 1)}
                            >
                              {i + 1}
                            </div>
                          </li>
                        );
                      })}

                    <li>
                      <div
                        className="relative block rounded  py-1.5 px-3 text-sm  transition-all duration-300  text-black cursor-pointer"
                        href="/"
                        onClick={() => {
                          if (currentPage < totalPageCount) {
                            setCurrentPage(currentPage + 1);
                          }
                        }}
                      >
                        {" >"}
                      </div>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            {open && (
              <FilterModal
                pagetype={pagetype}
                open={open}
                setOpen={setOpen}
                rating={rating}
                handleFilters={handleFilters}
                category={category}
                creators={creators}
                names={names}
                filters={myFilters.filters}
              />
            )}
          </>
        ) : (
          <></>
        )}
      </div>
    );
  };

  return (
    <>
      <Header />
      {CategoricalSearchPage()}
      <Footer />
    </>
  );
};

export default CategoricalSearch;
